import React from "react";
import {
  LuUsers,
  LuShield,
  LuLightbulb,
  LuCreditCard,
  LuAudioWaveform,
} from "react-icons/lu";
import Footer from "../../../components/footer";
import Header from "../../../components/header";

function HostComanPage() {
  return (
    <>
      <Header />
      <div className="mt-10 min-h-screen bg-white">
        {/* Main Content Section */}
        <section className="container mx-auto px-4 py-12 md:py-20">
          {/* Hero / Introduction */}
          <div className="text-center mb-12 md:mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-[#383885] mb-4">
              <strong>HOSTCOMAN</strong>
            </h1>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-6">
              <strong>
                Empowering Host Communities with Compliance & Transparency.
              </strong>
            </h2>
            <p className="text-lg md:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
              A digital platform for Licensees, Regulators, and Stakeholders to
              streamline Host Community Development Trust reporting, ensure
              transparency, and drive sustainable growth in Nigeria’s oil and
              gas host communities.
            </p>
          </div>

          {/* Transforming Resources Section */}
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Transforming Resources into Opportunities
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              HostComan is a digital solution designed to ensure transparency,
              compliance, and sustainable development in host communities
              affected by oil and gas activities. Built on transparency and
              sustainability, HostComan guarantees that host communities receive
              their rightful benefits, while streamlining regulatory compliance,
              transparent fund management, and equitable growth.
            </p>
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-lg shadow-xl p-8 flex hover:shadow-2xl transition-shadow">
              <LuAudioWaveform className="w-12 h-12 text-primary mr-6 flex-shrink-0" />
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Sustainable Growth
                </h3>
                <p className="text-gray-600">
                  Foster sustainable prosperity within host communities.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-xl p-8 flex hover:shadow-2xl transition-shadow">
              <LuUsers className="w-12 h-12 text-green-600 mr-6 flex-shrink-0" />
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Socio-Economic Benefit
                </h3>
                <p className="text-gray-600">
                  Provide direct social and economic benefits from petroleum
                  operations to host communities.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-xl p-8 flex hover:shadow-2xl transition-shadow">
              <LuShield className="w-12 h-12 text-blue-600 mr-6 flex-shrink-0" />
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Data Security
                </h3>
                <p className="text-gray-600">
                  Enhance peaceful coexistence between licensees and host
                  communities.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-xl p-8 flex hover:shadow-2xl transition-shadow">
              <LuLightbulb className="w-12 h-12 text-yellow-600 mr-6 flex-shrink-0" />
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Community Support
                </h3>
                <p className="text-gray-600">
                  Create a framework to support the long-term development of
                  host communities.
                </p>
              </div>
            </div>
          </div>

          {/* License-Based Model Card */}
          <div className="bg-white rounded-lg shadow-xl p-10">
            <div className="flex items-start">
              <LuCreditCard className="w-12 h-12 text-primary mr-8 flex-shrink-0" />
              <div className="flex-1">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  License-Based Model
                </h3>
                <p className="text-gray-600 mb-8">
                  HostComan follows a flexible license-based pricing structure
                  to meet the diverse needs of organizations and regulatory
                  bodies.
                </p>

                <div className="space-y-6">
                  <div className="flex">
                    <span className="font-bold text-2xl mr-6 text-primary">
                      •
                    </span>
                    <div>
                      <p className="text-lg">
                        <strong>Basic License: </strong>
                        Ideal for small organisations and single communities.
                      </p>
                    </div>
                  </div>

                  <div className="flex">
                    <span className="font-bold text-2xl mr-6 text-primary">
                      •
                    </span>
                    <div>
                      <p className="text-lg">
                        <strong>Standard License: </strong>
                        For medium-sized enterprises managing multiple
                        communities.
                      </p>
                    </div>
                  </div>

                  <div className="flex">
                    <span className="font-bold text-2xl mr-6 text-primary">
                      •
                    </span>
                    <div>
                      <p className="text-lg">
                        <strong>Enterprise License: </strong>
                        Comprehensive package for large-scale operations,
                        including advanced reporting and integrations.
                      </p>
                    </div>
                  </div>

                  <div className="flex">
                    <span className="font-bold text-2xl mr-6 text-primary">
                      •
                    </span>
                    <div>
                      <p className="text-lg">
                        <strong>Perpetual License: </strong>A one-time, upfront
                        payment option that grants the user unlimited access
                        with guaranteed support and updates for 10 years.
                        Renewable for support and update ONLY after 10 years.
                      </p>
                    </div>
                  </div>
                </div>

                <a
                  href="ContactUs.html"
                  className="inline-block mt-10 px-8 py-4 bg-primary text-white font-semibold rounded hover:bg-primary-dark transition-colors"
                >
                  Request a Quote
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default HostComanPage;
